import "./assets/styles/main.scss";
import "./App.scss";
import { useContext } from "react";
import { AuthContext } from "./contexts/AuthContext";

import Routers from "./routes/Routers";
import { CompanyContext } from "./contexts/CompanyContext";
import { AbilityProvider } from "./contexts/AbilityContext";

function App() {
  const { companyLoader } = useContext<any>(CompanyContext);
  const { isAuthenticated, isLoading } = useContext(AuthContext);

  if (companyLoader) {
    return <div>Loading...</div>;
  }

  if (isLoading) {
    return <>{isAuthenticated ? <div>Loading...</div> : <div>Loading...</div>}</>;
  }

  return (
    <AbilityProvider>
      <Routers />
    </AbilityProvider>
  );
}

export default App;
